import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { Table } from "reactstrap";
import Loader from "../../components/loader";
import ICInput from "../../components/form/input";

import appRoutes from "../../routes/appRoutes";
import {
  changeOnlineAssessmentStatusAPI,
  getInstantSwitchConsultDetailsMedicareAPI,
  getOrderHistoryAPI,
  toggleIsRequireSupportISAPI,
  updateConsultCostInstantSwitchAPI
} from "../../apiRoutes";
import { getFormattedDate } from "../../utils/dateTimeHelper";
import MakeAPICall from "../../apiCalls/common";
import APP_CONSTANTS from "../../constants";
import ICNoImg from "../../assets/images/default-picture.png";
import medicareImg from "../../assets/images/medicare-button.png";
import {
  ORDER_HISTORY_FILTERS,
  ORDER_HISTORY_STATUS,
  REVERSE_MAP_ORDER_HISTORY_STATUS_FOR_ADMIN
} from "../../constants/helperConstants";
import CustomModal from "../../components/modal";
import Label from "../../components/label";
import Anchor from "../../components/anchor";

const OnlineAssessmentsDetails = props => {
  const { id } = useParams();
  const history = useHistory();
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [data, setData] = useState(null);
  const [status, setStatus] = useState();
  const [selectedMBSItem, setSelectedMBSItem] = useState("");
  const [showMBSItemChangeModel, setShowMBSItemChangeModel] = useState(false);

  // status change
  const [showStatusChangeModel, setShowStatusChangeModel] = useState(false);

  // mark online assessment as not required support and all done
  const [showAttentionRequiredConfirmationModel, setShowAttentionRequiredConfirmationModel] = useState(false);

  // mark online assessment as to be assessed from accepted state
  const [showToBeAssessedStatusConfirmationModel, setShowToBeAssessedStatusConfirmationModel] = useState(false);

  const [isCodeEditMode, setIsCodeEditMode] = useState(false);
  const [consultCostVal, setConsultCostVal] = useState(0);

  const [newBulkItemVal, setNewBulkItemVal] = useState(0);
  const [isBulkItemEditMode, setIsBulkItemEditMode] = useState(false);

  const [modalText, setModalText] = useState("");
  const [showTextModal, setShowTextModal] = useState(false);

  const [showErrTextModal, setShowErrTextModal] = useState(false);
  const [modalErrText, setModalErrText] = useState("");

  // reset assessment
  const [openResetAssessmentDialog, setOpenResetAssessmentDialog] = useState(false);

  const handleCostEditChange = e => {
    setConsultCostVal(e.target.value);
  };

  const getDetails = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getOrderHistoryAPI,
      params: {
        assessmentId: id
      },
      successCallback: res => {
        let resData = res.data.data.orderHistoryData[0];
        let d = {};

        d._id = resData._id;

        d.appointmentId = resData.appointmentId;
        d.assessmentType = resData.assessmentType;
        d.submittedDate = getFormattedDate(resData.submittedDate);

        d.consultCost = resData.consultPrice ? resData.consultPrice.toFixed(2) : "-";
        d.pmFee = resData.PMFee ? resData.PMFee.toFixed(2) : "-";
        d.tax = resData.tax ? resData.tax.toFixed(2) : "-";
        d.status = resData.assessmentStatus ? ORDER_HISTORY_STATUS[resData.assessmentStatus] : "";
        setStatus(ORDER_HISTORY_STATUS[resData.assessmentStatus]);

        d.isBulkBilled = resData.isBulkBilled;
        d.assessmentQuestions = resData.assessmentQuestions;
        d.receipt = resData.paymentSlip ? resData.paymentSlip : "";

        // d.completedDate = null;
        // d.acceptedDate = null;
        // d.rejectedDate = null;
        if (resData.assessmentStatus === ORDER_HISTORY_FILTERS.COMPLETED) {
          d.completedDate = getFormattedDate(resData.completedDate);
        } else if (resData.assessmentStatus === ORDER_HISTORY_FILTERS.REJECTED) {
          d.rejectedDate = getFormattedDate(resData.rejectedDate);
        } else if (resData.assessmentStatus === ORDER_HISTORY_FILTERS.ACCEPTED) {
          d.acceptedDate = getFormattedDate(resData.acceptedDate);
        }


        // d.practitionerDetails = {};
        d.patientDetails = {};
        d.practitionerBankDetails = {};
        d.lastFourDigit = null;

        if (resData.doctorId) {
          d.practitionerDetails = {};
          d.practitionerDetails.uin = resData.doctorId.doctorId;
          d.practitionerDetails.name = resData.doctorId.firstName + " " + resData.doctorId.lastName;
          d.practitionerDetails.email = resData.doctorId.email;
          // d.practitionerDetails.phoneNumber = resData.doctorId.phoneNumber;
          d.practitionerDetails.profilePicture = resData.doctorId.profilePic ? resData.doctorId.profilePic.original : ICNoImg;

          d.practitionerDetails.bankName = resData.doctorId.manageAccount.bankAccountName;
          d.practitionerDetails.bankAccountNo = resData.doctorId.manageAccount.bankAccoutLastFourDigit;
          d.practitionerDetails.bankAccountName = resData.doctorId.manageAccount.accountHolderName;
          d.practitionerDetails.bsb = resData.doctorId.manageAccount.routingNumber;

          if (resData.doctorId.phoneNumber) {
            const mobileNo = resData.doctorId.phoneNumber.replace(/\s/g, "");
            d.practitionerDetails.phoneNumber = `${mobileNo.substr(0, 4)} ${mobileNo.substr(4, 3)} ${mobileNo.substr(7, 10)}`;
          } else {
            d.practitionerDetails.phoneNumber = "";
          }

        } else {
          d.practitionerDetails = null;
        }

        var consultPrice = resData.consultPrice.toFixed(2);
        const PMFee = resData.PMFee ? (+resData.PMFee).toFixed(2) : 0;
        const taxAmount = resData.tax ? (+resData.tax).toFixed(2) : 0;

        let bulkBillIncentiveEarning = 0;
        d.isBulkIncentiveAdded = resData.isBulkIncentiveAdded || false;
        if (resData.isBulkIncentiveAdded) {
          bulkBillIncentiveEarning = resData.bulkIncentiveDetails.price ? +resData.bulkIncentiveDetails.price : 0;
          // consultPrice = (+consultPrice + +resData.bulkIncentiveDetails.price).toFixed(2);
          d.incentiveAmount = resData.bulkIncentiveDetails.price;
          d.mbsIncentiveItemNo = resData.bulkIncentiveDetails.itemNo;
        }
        d.mbsItem = resData.consultDetailMedicareId ? resData.consultDetailMedicareId.mbsItemNo : null;

        const sumOfTotalConsultCost = +consultPrice + +bulkBillIncentiveEarning;
        const totalEarning = (sumOfTotalConsultCost - PMFee - taxAmount).toFixed(2);

        setConsultCostVal(consultPrice);

        d.earnings = "$" + totalEarning;
        d.pmFee = "$" + PMFee;
        d.tax = "$" + taxAmount;

        if (resData.patientCardId && resData.patientCardId.stripePatientId) {
          d.lastFourDigit = resData.patientCardId.lastFourDigit;
        }

        d.patientDetails._id = resData.patientId._id;
        d.patientDetails.uin = resData.patientId.patientId;
        d.patientDetails.name = resData.patientId.firstName + " " + resData.patientId.lastName;
        d.patientDetails.email = resData.patientId.email;

        if (resData.patientId.phoneNumber) {
          const mobileNo = resData.patientId.phoneNumber.replace(/\s/g, "");
          d.patientDetails.phoneNumber = `${mobileNo.substr(0, 4)} ${mobileNo.substr(4, 3)} ${mobileNo.substr(7, 10)}`;
        } else {
          d.patientDetails.phoneNumber = "";
        }

        d.patientDetails.cardLastFourDigits = resData.cardLast4Digits;
        d.patientDetails.profilePicture = resData.patientId.profilePic ? resData.patientId.profilePic.original : ICNoImg;

        d.additionalInfo = resData.additionalInfo || "-";

        d.isRequireSupport = resData.isRequireSupport ? true : false;
        d.isBulkBilled = resData.isBulkBilled ? true : false;
        d.consultDetailMedicareId = resData.consultDetailMedicareId ? resData.consultDetailMedicareId : "";
        setSelectedMBSItem(d.consultDetailMedicareId);

        d.attachments = resData.attachments ? resData.attachments : [];
        d.assessmentPDF = resData.assessmentPDF ? resData.assessmentPDF : "";
        d.treatmentPlan = resData.treatmentPlan ? resData.treatmentPlan : {};
        d.paymentSlip = resData.paymentSlip ? resData.paymentSlip : "";
        d.paymentSummary = resData.paymentSummary ? resData.paymentSummary : "";
        d.taxSummary = resData.taxSummary ? resData.taxSummary : "";

        d.consultNoteId = resData.consultNoteId && resData.consultNoteId.isInstantSwitch ? resData.consultNoteId : null;

        // if (!d.isBulkBilled) {
        //     setIsCodeEditMode(true);
        // }

        setData(d);
        if (resData.isBulkBilled) {
          d.DB4FormLink = resData.DB4FormLink ? resData.DB4FormLink : "";
          getMedicareConstants();
        }

        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };

  const getMedicareConstants = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getInstantSwitchConsultDetailsMedicareAPI,
      params: {
        skip: 0,
        limit: 20
      },
      successCallback: async res => {
        // setMedicareConstants(res.data.data.consultDetailData);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };

  const markOnlineAssessmentAsDone = () => {
    setIsProcessing(true);
    setShowAttentionRequiredConfirmationModel(false);

    setApiCallParams({
      reqType: "POST",
      reqUrl: toggleIsRequireSupportISAPI,
      dataObj: {
        assessmentId: data._id,
        isRequireSupport: !data.isRequireSupport
      },
      successCallback: async res => {
        setIsProcessing(false);
        getDetails();
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };

  const markOnlineAssessmentAsToBeAssessed = () => {
    setIsProcessing(true);
    setShowToBeAssessedStatusConfirmationModel(false);
    setOpenResetAssessmentDialog(false);

    setApiCallParams({
      reqType: "POST",
      reqUrl: toggleIsRequireSupportISAPI,
      dataObj: {
        assessmentId: data._id,
        isRequireSupport: false,
        changeStatusTo: ORDER_HISTORY_FILTERS.TO_BE_ASSESSED
      },
      successCallback: async res => {
        setIsProcessing(false);
        getDetails();
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };


  const applyNewConsultCost = isBulkBilled => {
    let proceed = false;
    let itemCost = consultCostVal;

    if (
      isBulkBilled === false &&
      data.consultCost &&
      data.consultCost !== consultCostVal
    ) {
      proceed = true;
    } else if (
      (data.consultDetailMedicareId &&
        data.consultDetailMedicareId.mbsItemNo !== newBulkItemVal) ||
      data.consultDetailMedicareId === undefined ||
      data.consultDetailMedicareId === null
    ) {
      proceed = true;
      itemCost = newBulkItemVal;
    }

    setIsCodeEditMode(false);
    setIsBulkItemEditMode(false);

    if (proceed === true) {
      setIsProcessing(true);
      setApiCallParams({
        reqType: "PUT",
        reqUrl: updateConsultCostInstantSwitchAPI,
        dataObj: {
          assessmentId: data._id,
          isBulkBilled: isBulkBilled,
          newConsultCost: itemCost,
          medicareCostId: itemCost
        },
        successCallback: res => {
          setIsProcessing(false);
          setModalText("Consult Details Updated Successfully");
          setShowTextModal(true);
          getDetails();
        },
        failureCallback: err => {
          setIsProcessing(false);
          setConsultCostVal(data.consultCost);
          setNewBulkItemVal(
            data.consultDetailMedicareId
              ? data.consultDetailMedicareId.mbsItemNo
              : 0
          );
        }
      });
    }
  };

  const handleStatusChange = (event) => {
    const statusVal = event.target.value;
    setStatus(statusVal);
    setShowStatusChangeModel(true);
  };

  const toggleMarkingSuccessfulButton = () => {
    setShowAttentionRequiredConfirmationModel(!showAttentionRequiredConfirmationModel);
  };

  const toggleMarkingToBeAssessedButton = () => {
    setShowToBeAssessedStatusConfirmationModel(!showToBeAssessedStatusConfirmationModel);
  };

  const handleMBSItemChange = (itemId) => {
    const mbsItemId = itemId;
    setSelectedMBSItem(mbsItemId);
    setShowMBSItemChangeModel(true);
  };

  const changeMBSItemCost = () => {
    console.log("Call API to change item and generate everything again: ", selectedMBSItem, data);
  };

  const changeAssessmentStatus = () => {
    setIsProcessing(true);
    setShowStatusChangeModel(false);

    const dataToUpdate = {
      assessmentStatus: REVERSE_MAP_ORDER_HISTORY_STATUS_FOR_ADMIN[status],
      assessmentId: data._id
    };

    setApiCallParams({
      reqType: "POST",
      reqUrl: changeOnlineAssessmentStatusAPI,
      dataObj: dataToUpdate,
      successCallback: async res => {
        setIsProcessing(false);
        getDetails();
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };

  const openAttachment = (attachment) => {
    window.open(attachment.url, "_blank");
  };

  const handleBulkItemEditChange = e => {
    setNewBulkItemVal(e.target.value);
  };

  const openPMS = (patientId) => {
    const auth = props.auth.user;
    window.open(
      APP_CONSTANTS.pmsURL +
      "/patient/patientDetails?accessToken=" +
      auth.accessToken +
      "&patientId=" +
      patientId +
      "&searchType=" +
      auth.userType +
      "&adminName=" +
      auth.firstName +
      " " +
      auth.lastName,
      "_blank"
    );
  };

  const markAssessmentAsAccepted = () => {
    setOpenResetAssessmentDialog(false);
    if (data.status === ORDER_HISTORY_STATUS.COMPLETED || data.status === ORDER_HISTORY_STATUS.REJECTED) {
      setIsProcessing(true);

      setApiCallParams({
        reqType: "POST",
        reqUrl: toggleIsRequireSupportISAPI,
        dataObj: {
          assessmentId: data._id,
          isRequireSupport: false,
          changeStatusTo: ORDER_HISTORY_FILTERS.ACCEPTED
        },
        successCallback: async res => {
          setIsProcessing(false);
          getDetails();
        },
        failureCallback: err => {
          setIsProcessing(false);
        }
      });
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  return (
    <>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : "p-5 row m-0"}>
        <div className="col-sm-12 p-0">
          <NavLink
            to={{
              pathname: appRoutes.instantExtraAssessments
            }}
            className="details-back-link"
            href="#"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 back-btn-text"> Back to Assessments</span>
          </NavLink>
        </div>
        <div className="col-sm-12 p-0 mt-4">
          <h3 className="">Assessment Details</h3>
        </div>

        {
          data && (
            <>
              <div className="col-sm-12 p-0 mt-3">
                <div className="card w-100 p-3">
                  <div className="row p-0 m-0">

                    <div className="col-sm-12 mb-3 text-center pb-2 border-bottom">
                      <Label
                        className="m-0 large secondary-font"
                        title="Patient Details"
                      />
                    </div>

                    <div className="col-sm-3 center-align-with-flex">
                      <img src={data.patientDetails.profilePicture} className="user-profile-pic-auto-width"
                           alt="User_IMG" />
                    </div>

                    <div className="col-sm-4 center-align-with-flex">
                      <div className="row">
                        <div className="col-sm-12">
                          <Label
                            className="m-0"
                            title="UIN: "
                          />
                          <div className="d-inline cursor-pointer" onClick={e => {
                            e.stopPropagation();
                            openPMS(data.patientDetails._id);
                          }}>
                            <Label
                              className="secondary-font m-0 ml-2 insta-link-orange cursor-pointer"
                              title={data.patientDetails.uin}
                            />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <Label
                            className="m-0"
                            title="Patient Name: "
                          />
                          <Label
                            className="secondary-font m-0 ml-2"
                            title={`${data.patientDetails.name}`}
                          />
                        </div>
                        <div className="col-sm-12">
                          <Label
                            className="m-0"
                            title="Mobile No: "
                          />
                          <Label
                            className="secondary-font m-0 ml-2"
                            title={`${data.patientDetails.phoneNumber}`}
                          />
                        </div>
                        <div className="col-sm-12">
                          <a className="insta-link-orange"
                             href={data.assessmentPDF}
                             target="_blank">
                            Download Online Assessment
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-5 center-align-with-flex">
                      <div className="row">
                        <div className="col-sm-12">
                          <Label
                            className="m-0"
                            title="Assessment ID:"
                          />
                          <Label
                            className="secondary-font m-0 ml-2"
                            title={data.appointmentId}
                          />
                        </div>
                        <div className="col-sm-12">
                          <Label
                            className="m-0"
                            title="Billing Type: "
                          />
                          <Label
                            className="secondary-font m-0 ml-2"
                            title={data.isBulkBilled ? "Medicare" : "Private"}
                          />
                        </div>

                        <div className="col-sm-12">
                          <Label
                            className="m-0"
                            title="Submitted Date: "
                          />
                          <Label
                            className="secondary-font m-0 ml-2"
                            title={data.submittedDate}
                          />
                        </div>

                        {
                          data.completedDate && !data.isRequireSupport ? (
                            <div className="col-sm-12 primary-font cursor-pointer" onClick={() => {
                              setOpenResetAssessmentDialog(true);
                            }}>
                              <Label
                                className="m-0 cursor-pointer primary-font"
                                title="Completed Date: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2 cursor-pointer primary-font"
                                title={data.completedDate}
                              />
                            </div>
                          ) : (
                            <div className={data.completedDate ? "col-sm-12 cursor-pointer" : "d-none"}
                                 onClick={toggleMarkingSuccessfulButton}>
                              <Label
                                className="m-0 red cursor-pointer"
                                title="Completed Date: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2 red cursor-pointer"
                                title={data.completedDate}
                              />
                            </div>
                          )
                        }
                        {
                          data.acceptedDate && (
                            <div className="col-sm-12 cursor-pointer" onClick={toggleMarkingToBeAssessedButton}>
                              <Label
                                className="m-0 light-blue cursor-pointer"
                                title="Accepted Date: "
                              />
                              <Label
                                className="secondary-font light-blue m-0 ml-2 cursor-pointer"
                                title={data.acceptedDate}
                              />
                            </div>
                          )
                        }

                        {
                          data.rejectedDate && (
                            <div className="col-sm-12">
                              <Label
                                className="m-0"
                                title="Rejected Date: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.rejectedDate}
                              />
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </div>
                {/* Doctor Information */}
                {
                  data.practitionerDetails && (
                    <div className="card w-100 p-3 mt-3">
                      <div className="row p-0 m-0">
                        <div className="col-sm-12 mb-3 text-center pb-2 border-bottom">
                          <Label
                            className="m-0 large secondary-font"
                            title="Doctor Details"
                          />
                        </div>
                        <div className="col-sm-3 center-align-with-flex">
                          <img src={data.practitionerDetails.profilePicture} className="user-profile-pic-auto-width"
                               alt="User_IMG" />
                        </div>
                        <div className="col-sm-4 center-align-with-flex">
                          <div className="row">
                            <div className="col-sm-12">
                              <Label
                                className="m-0"
                                title="UIN: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.practitionerDetails.uin}
                              />
                            </div>
                            <div className="col-sm-12">
                              <Label
                                className="m-0"
                                title="Doctor Name: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={`${data.practitionerDetails.name}`}
                              />
                            </div>
                            <div className="col-sm-12">
                              <Label
                                className="m-0"
                                title="Mobile No: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={`${data.practitionerDetails.phoneNumber}`}
                              />
                            </div>
                            {
                              (data.status !== ORDER_HISTORY_STATUS.TO_BE_ASSESSED && data.status !== ORDER_HISTORY_STATUS.ACCEPTED && data.status !== ORDER_HISTORY_STATUS.REJECTED) && (
                                <>
                                  <div className="col-sm-12">
                                    <a
                                      className="insta-link-orange"
                                      href={data && data.paymentSummary ? data.paymentSummary : ""}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {data && data.paymentSummary ? "View Consult Payment Summary" : "Payment Summary Not Available"}
                                    </a>
                                  </div>
                                  <div className="col-sm-12">
                                    <a
                                      className="insta-link-orange"
                                      href={data && data.taxSummary ? data.taxSummary : ""}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {data && data.taxSummary ? "View Consult Tax Invoice" : "Tax Invoice Not Available"}
                                    </a>
                                  </div>
                                </>
                              )
                            }
                          </div>
                        </div>

                        <div className="col-sm-5 center-align-with-flex">
                          <div className="row">
                            <div className="col-sm-12">
                              <Label
                                className="m-0"
                                title="Bank Name"
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.practitionerDetails.bankName}
                              />
                            </div>
                            <div className="col-sm-12">
                              <Label
                                className="m-0"
                                title="Account Number"
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.practitionerDetails.bankAccountNo}
                              />
                            </div>
                            <div className="col-sm-12">
                              <Label
                                className="m-0"
                                title="Account Name"
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.practitionerDetails.bankAccountName}
                              />
                            </div>
                            <div className="col-sm-12">
                              <Label
                                className="m-0"
                                title="BSB"
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.practitionerDetails.bsb}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

                {/* Doctor Information */}
                {
                  data.status === ORDER_HISTORY_STATUS.COMPLETED && (
                    <div className="card w-100 p-3 mt-3">
                      <div className="row p-0 m-0">
                        <div className="col-sm-12 mb-3 text-center pb-2 border-bottom">
                          <Label
                            className="m-0 large secondary-font"
                            title="Cost Details"
                          />
                        </div>

                        <div className="col-sm-12">
                          <div className="row p-0 m-0">
                            <div className={data.isBulkBilled ? "col-sm-3" : "col-sm-4"}>
                              <Label
                                className="m-0"
                                title="Consult Cost: "
                              />
                              {
                                !isCodeEditMode && (
                                  <Label
                                    className="secondary-font m-0 ml-2"
                                    title={"$" + data.consultCost}
                                  />
                                )
                              }

                              <span>
                                {isCodeEditMode === true && (
                                  <ICInput
                                    style={{ width: "20%" }}
                                    name="consutCost"
                                    type="number"
                                    className="ml-2"
                                    onChange={handleCostEditChange}
                                    value={consultCostVal}
                                  />
                                )}
                              </span>
                              {isCodeEditMode === false && data.isBulkBilled === false && (
                                <button
                                  type="button"
                                  className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                                  onClick={() => {
                                    setIsCodeEditMode(true);
                                  }}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                              )}
                              {isCodeEditMode === true && (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                                    onClick={() => applyNewConsultCost(false)}
                                  >
                                    <i className="fas fa-save"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    type="button"
                                    className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                                    onClick={() => {
                                      setIsCodeEditMode(false);
                                      setConsultCostVal(data.consultCost);
                                    }}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </>
                              )}

                              {
                                data.isBulkIncentiveAdded && (
                                  <div className="mt-2 mb-2">
                                    <Label
                                      className="m-0"
                                      title="Incentive: "
                                    />
                                    <Label
                                      className="secondary-font m-0 ml-2"
                                      title={"$" + data.incentiveAmount}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            {
                              !data.isBulkBilled && (
                                <div className="col-sm-4 offset-sm-4 pt-1">
                                  <a
                                    className="insta-link-orange font-15"
                                    href={data && data.paymentSlip ? data.paymentSlip : ""}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {data && data.paymentSlip ? "View Consult Receipt" : "Receipt Not Available"}
                                  </a>
                                </div>
                              )
                            }

                            {
                              data.isBulkBilled && (
                                <>
                                  <div className="col-sm-4">
                                    <Label
                                      className="m-0"
                                      title="MBS Item Number: "
                                    />
                                    {
                                      !isBulkItemEditMode && (
                                        <Label
                                          className="secondary-font m-0 ml-2"
                                          title={data.mbsItem}
                                        />
                                      )
                                    }

                                    <span>
                                      {isBulkItemEditMode === true && (
                                        <ICInput
                                          style={{
                                            width: "20%",
                                            marginLeft: "20px"
                                          }}
                                          name="bulkItemNo"
                                          type="number"
                                          onChange={handleBulkItemEditChange}
                                          value={newBulkItemVal}
                                        />
                                      )}
                                    </span>
                                    {isBulkItemEditMode === false && (
                                      <button
                                        type="button"
                                        className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                                        onClick={() => {
                                          setIsBulkItemEditMode(true);
                                        }}
                                      >
                                        <i className="fas fa-edit"></i>
                                      </button>
                                    )}
                                    {isBulkItemEditMode === true && (
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                                          onClick={() => applyNewConsultCost(true)}
                                        >
                                          <i className="fas fa-save"></i>
                                        </button>
                                        &nbsp;
                                        <button
                                          type="button"
                                          className="btn btn-out-bell high-z-index ml-2 consult-cost-edit-btns"
                                          onClick={() => {
                                            setIsBulkItemEditMode(false);
                                            setNewBulkItemVal(
                                              data.consultDetailMedicareId
                                                ? data.consultDetailMedicareId.mbsItemNo
                                                : ""
                                            );
                                          }}
                                        >
                                          <i className="fas fa-times"></i>
                                        </button>
                                      </>
                                    )}
                                    {
                                      data.isBulkIncentiveAdded && (
                                        <div className="mb-2">
                                          <Label
                                            className="m-0"
                                            title="MBS Item Number: "
                                          />
                                          <Label
                                            className="secondary-font m-0 ml-2"
                                            title={data.mbsIncentiveItemNo}
                                          />
                                        </div>
                                      )
                                    }
                                  </div>
                                  <div className="col-sm-5 p-0">
                                    <img
                                      style={{ height: "25px" }}
                                      src={medicareImg}
                                      alt="medicare-logo"
                                      className="float-left"
                                    />
                                    <p className="mb-0 pt-1">
                                      {data.DB4FormLink === "#" && (
                                        <span className="ml-2">
                                                                                    No Bulk-Bill Assignment of Benefit Form DB4
                                                                                    Available
                                                                                </span>
                                      )}
                                      {data.DB4FormLink !== "#" && (
                                        <a
                                          className="insta-link-orange"
                                          href={data.DB4FormLink}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Bulk-Bill Assignment of Benefit Form DB4
                                        </a>
                                      )}
                                    </p>
                                  </div>
                                </>
                              )
                            }
                          </div>
                        </div>

                        <div className="col-sm-12 mt-1 mb-1 border-bottom">
                        </div>

                        <div className="col-sm-12 mt-2">
                          <div className="row p-0 m-0">
                            <div className="col-md-4">
                              <Label
                                className="m-0"
                                title="Practice Management Fee: "
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.pmFee}
                              />

                            </div>
                            <div className="col-md-4">
                              <Label
                                className="m-0"
                                title="GST on Practice Management Fee:"
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.tax}
                              />
                            </div>
                            <div className="col-md-4">
                              <Label
                                className="m-0"
                                title="Doctor's Earning:"
                              />
                              <Label
                                className="secondary-font m-0 ml-2"
                                title={data.earnings}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

                <div className="card w-100 p-3 mt-3">
                  <Label
                    className="m-0 large w-100"
                    title="Additional Information: "
                  />
                  <Label
                    className="m-0 w-100"
                    title={data.additionalInfo ? data.additionalInfo : "-"}
                  />
                </div>
              </div>

              {/* Consult Note */}
              {
                data.consultNoteId && data.consultNoteId.isInstantSwitch && (
                  <div className="col-sm-12 mt-3 p-0">
                    <div className="card w-100 p-3">
                      <div className="row">
                        <div className="col-sm-12">
                          <Label
                            className="m-0 secondary-font"
                            title="Consult Note: "
                          />
                          <p className={"insta-label "}
                             dangerouslySetInnerHTML={{
                               __html: (data.consultNoteId.note).replace(/\r?\n/g, "<br/>")
                             }}
                          />
                        </div>
                        <div className="col-sm-12">
                          {
                            data.consultNoteId.attachments.map((attachment, index) => {
                              return (
                                !attachment.isDeleted ? (
                                  <div className="prescription-attachments cursor-pointer mr-2 mt-2" key={index}>
                                    <div className="pdf-text cursor-pointer" onClick={() => openAttachment(attachment)}>
                                      <Label title="PDF" className="cursor-pointer" />
                                    </div>
                                    <div className="attachment-type-name cursor-pointer"
                                         onClick={() => openAttachment(attachment)}>
                                      <Label title="ePrescription.pdf" className="cursor-pointer ml-3" />
                                    </div>
                                  </div>
                                ) : ("")
                              );
                            })
                          }

                          {
                            data.consultNoteId.instantSwitchAttachments.map((attachment, index) => {
                              return (
                                <div className="prescription-attachments cursor-pointer mr-2 mt-2 disabled-link "
                                     key={index}>
                                  <div className="pdf-text cursor-pointer gray-bg-new-color"
                                       onClick={() => openAttachment(attachment)}>
                                    <i className="fas fa-envelope envelop-btn text-center pl-1 text-white font-17"></i>
                                  </div>
                                  <div className="attachment-type-name cursor-pointer"
                                       onClick={() => openAttachment(attachment)}>
                                    <Label title={attachment.type} className="cursor-pointer ml-3" />
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }

              {/* Treatment Plan */}
              {
                ((data.status !== ORDER_HISTORY_STATUS.REJECTED && data.status !== ORDER_HISTORY_STATUS.ACCEPTED && data.status !== ORDER_HISTORY_STATUS.TO_BE_ASSESSED) && data.treatmentPlan) && (
                  <div className="col-sm-12 mt-3 p-0">
                    <div className="card w-100 p-3">
                      <div className="row">
                        <div className="col-sm-12">
                          <Label
                            className="m-0 w-100 secondary-font"
                            title="Information for Patient (from Doctor):"
                          />
                          <p
                            className={"insta-label "}
                            dangerouslySetInnerHTML={{
                              __html: (data.treatmentPlan.additionalNoteForEmail ? data.treatmentPlan.additionalNoteForEmail : "-").replace(/\r?\n/g, "<br/>")
                            }}
                          />
                        </div>

                        {data.assessmentType !== "Medicinal Cannabis" && <div className="col-sm-12 mt-3">
                          <Anchor
                            title="Attached Pamphlet"
                            href={data.treatmentPlan.patientAttachedPDF}
                            className="insta-link-orange mr-3 secondary-font font-15"
                            target="_blank"
                          />

                          {
                            data.treatmentPlan.nicovapeQPDF && (
                              <Anchor
                                title="Welcome To Nicovape Q"
                                href={data.treatmentPlan.nicovapeQPDF}
                                className="insta-link-orange mr-3 secondary-font font-15"
                                target="_blank"
                              />
                            )
                          }
                        </div>}

                        {/* Show Drug Listing table if there are any types of drugs added */}
                        {/* Probably Rejected Assessments won't have drugs */}

                        {
                          data.treatmentPlan.types.length ? (
                            <div className="col-sm-12 mt-3">
                              <Table>
                                <thead>
                                <tr>
                                  <th>Type</th>
                                  <th>Selected Drug</th>
                                  <th>Drug Information</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.treatmentPlan.types.map((selectedType, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{selectedType.typeName} {selectedType.combinationTherapyType ? " - " + selectedType.combinationTherapyType : ""}</td>
                                      <td> {selectedType.drug ? selectedType.drug : "-"}</td>
                                      <td>
                                        {
                                          selectedType.drugs.map((drugInfo, i2) => {
                                            return (
                                              <div className="drugInfo-container" key={i2 + i2}>
                                                <div className="drugInfo">
                                                  <p className="title">Name</p>
                                                  <p className="content">{drugInfo.name}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Strength</p>
                                                  <p className="content">{drugInfo.strength || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Form Type</p>
                                                  <p className="content">{drugInfo.formType || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Dose</p>
                                                  <p className="content">{drugInfo.dose || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Frequency</p>
                                                  <p className="content">{drugInfo.frequency || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Quantity</p>
                                                  <p className="content">{drugInfo.quantity || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Repeats</p>
                                                  <p className="content">{drugInfo.repeats || "-"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Regulation 24</p>
                                                  <p className="content">{drugInfo.regulation24 ? "Yes" : "No"}</p>
                                                </div>
                                                <div className="drugInfo">
                                                  <p className="title">Other Details</p>
                                                  <p className="content">{drugInfo.otherPrescriptionDetails || "-"}</p>
                                                </div>
                                              </div>
                                            );
                                          })
                                        }
                                        {
                                          !selectedType.drugs.length && ("-")
                                        }
                                      </td>
                                    </tr>
                                  );
                                })}
                                </tbody>
                              </Table>
                            </div>
                          ) : ("")
                        }
                      </div>
                    </div>
                  </div>
                )
              }
            </>
          )
        }
      </div>
      <CustomModal
        openModal={showMBSItemChangeModel}
        cancelEvent={() => {
          setShowMBSItemChangeModel(false);
          setSelectedMBSItem(data.consultDetailMedicareId);
        }}
        cancelText="Close"
        okayEvent={changeMBSItemCost}
        okayText="Confirm"
        title="Instant Switch"
        modalBodyContent={
          <p>Are you sure you want to update MBS item?</p>
        }
      />

      {/* Remove Attention Required */}
      <CustomModal
        openModal={showAttentionRequiredConfirmationModel}
        cancelEvent={() => {
          setShowAttentionRequiredConfirmationModel(false);
        }}
        cancelText="Close"
        okayEvent={markOnlineAssessmentAsDone}
        okayText="Confirm"
        title={<p className="text-center mb-0">Instant Switch</p>}
        useOneButton={false}
        modalBodyContent={
          <p className="text-center mb-0">Are you sure you want to mark this assessment as completed?</p>
        }
      />

      {/* Mark online assessment as To Be Assessed */}
      <CustomModal
        openModal={showToBeAssessedStatusConfirmationModel}
        cancelEvent={() => {
          setShowToBeAssessedStatusConfirmationModel(false);
        }}
        cancelText="Close"
        okayEvent={markOnlineAssessmentAsToBeAssessed}
        okayText="Confirm"
        title={<p className="text-center mb-0">Instant Switch</p>}
        useOneButton={false}
        modalBodyContent={
          <p className="text-center mb-0">Are you sure you want to change the status to 'To Be Assessed'?</p>
        }
      />

      {/* Mark online assessment as Accepted */}
      <CustomModal
        openModal={openResetAssessmentDialog}
        cancelEvent={() => {
          setOpenResetAssessmentDialog(false);
        }}
        cancelText="Close"
        okayEvent={markAssessmentAsAccepted}
        okayText="Confirm"
        title={<p className="text-center mb-0">Instant Switch</p>}
        useOneButton={false}
        modalBodyContent={
          <p className="text-center mb-0">Are you sure you want to change the status to 'Accepted'?</p>
        }
      />

      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
          history.push(appRoutes.instantSwitchOnlineAssessments);
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />

      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrTextModal}
        cancelEvent={() => {
          setShowErrTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalErrText}</p>}
      />

      <CustomModal
        openModal={showStatusChangeModel}
        cancelEvent={() => {
          setStatus(data.status);
          setShowStatusChangeModel(false);
        }}
        cancelText="Close"
        okayEvent={changeAssessmentStatus}
        okayText="Confirm"
        title="Instant Switch"
        modalBodyContent={
          <p>Are you sure you want to update status?</p>
        }
      />
      <MakeAPICall apiParam={apiCallParams} />
    </ >
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(OnlineAssessmentsDetails);
